// This module provides API call methods for Sephora Commerce Authentication APIs:
// https://jira.sephora.com/wiki/display/ILLUMINATE/Authentication+APIs


// TO WHOM IT MAY CONCERN,
//
// Please do your best honest work of factoring out any of the related API
// calls from other places into this module as soon as there's an assignment
// related to this scope.


const { login } = require('./login');
const logout = require('./logout');
const resetPassword = require('./resetPassword');
const validatePasswordToken = require('./validatePasswordToken');
const getSdnAuthToken = require('./getSdnAuthToken').getSdnAuthToken;

module.exports = {
    login,
    logout,
    resetPasswordByLogin: resetPassword.resetPasswordByLogin,
    resetPassword: resetPassword.resetPassword,
    validatePasswordToken,
    getSdnAuthToken
};
